export const BILLTYPE = {
  RENT: 0, // 租宝
  SALE: 1, // 售宝
};

export const BILL_EXPORT_TYPE = {
  Billed: 1, //  已出账单
  UnBilled: 2, //  未出账单
};

export const ACTIVITY_BILL_TYPE = {
  UNBILLED: 0,
  BILLED: 1,
};
export const COUPON_TYPE = {
  DISCOUNT: 30, // 折扣券
  TIME: 20, // 时长券
  FREE_TIME: 10, // 免费时长券
  FREEDISCOUNT: 40, // 免费折扣券
};

export const COUPON_TYPE_OPTIONS = [
  {
    label: '收费折扣券',
    value: COUPON_TYPE.DISCOUNT,
  },
  {
    label: '收费时长券',
    value: COUPON_TYPE.TIME,
  },
  {
    label: '免费时长券',
    value: COUPON_TYPE.FREE_TIME,
  },
  {
    label: '免费折扣券',
    value: COUPON_TYPE.FREEDISCOUNT,
  },
];

export const SHARE_MODE = { // 分润模式
  DEFAULT: 0, // 默认
  BASE: 1, // 基础
  STAR: 2, // 星级
  MIDDLE: 3, // 居间
};
